import { callApiNew } from 'src/middleware/apiMiddleware';

const generateCardDetails = (businessUuid: string) =>
  callApiNew<ActivationCard>({
    endpoint: `/business/${businessUuid}/generate-card`,
    method: 'post',
  });

const verifyPaymentToProceed = (businessUuid: string) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/business/${businessUuid}/verify-payment`,
  });

const postConfirmMapping = (businessUuid: string) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/business/${businessUuid}/confirm-mapping`,
    method: 'post',
  });

const setConfirmMapping = (businessUuid: string, posIdentifier: string) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/business/${businessUuid}/set-descriptor`,
    method: 'post',
    body: { posIdentifier },
  });

const postContactSupport = (businessUuid: string, posIdentifier: string) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/contact/support/business/${businessUuid}/pos-descriptor`,
    method: 'post',
    body: { posIdentifier },
  });

const rejectDescriptor = (businessUuid: string, listedBusinessUuid: string, isManual: boolean = true) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/business/${businessUuid}/reject-${isManual ? 'manual' : 'auto'}-descriptor/${listedBusinessUuid}`,
  });

const acceptDescriptor = (businessUuid: string, listedBusinessUuid: string, isManual: boolean = true) =>
  callApiNew<PosIndentifierResponse>({
    endpoint: `/business/${businessUuid}/accept-${isManual ? 'manual' : 'auto'}-descriptor/${listedBusinessUuid}`,
  });

const apiUtil = {
  generateCardDetails,
  verifyPaymentToProceed,
  postConfirmMapping,
  postContactSupport,
  setConfirmMapping,
  rejectDescriptor,
  acceptDescriptor,
};

export default apiUtil;
